<app-navbar></app-navbar>
<router-outlet></router-outlet>
<p class="mt-5"></p>
<app-subscribe></app-subscribe>
<app-footer></app-footer>
<!-- <ngx-scrolltop></ngx-scrolltop> -->
<notifier-container></notifier-container>
<app-afrobot></app-afrobot>
<app-cookie-consent></app-cookie-consent>